import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root, [data-theme="light"] {
    --bg: #f7f6f2;
    --bg-elevated: #ffffff;
    --bg-inverted: #14181f;
    --text-primary: #14181f;
    --text-secondary: #5b636d;
    --text-muted: #8a9099;
    --text-on-inverted: #f2f0ea;
    --text-on-inverted-muted: #a9afb6;
    --border: #e1e0d8;
    --border-inverted: #262b33;
    --accent: #2f5d80;
    --accent-strong: #1f4560;
    --accent-soft: #e6edf2;
    --accent-secondary: #5b6b78;
    --accent-on-inverted: #83b1d6;
    --contact-bg: #1c3550;
    --contact-bg-strong: #142737;
    --success: #2f9e6a;
    --shadow: 0 12px 30px rgba(20, 24, 31, 0.08);
  }

  [data-theme="dark"] {
    --bg: #10131a;
    --bg-elevated: #171b23;
    --bg-inverted: #f2f0ea;
    --text-primary: #f2f0ea;
    --text-secondary: #aab0b8;
    --text-muted: #767c85;
    --text-on-inverted: #14181f;
    --text-on-inverted-muted: #5b636d;
    --border: #262b34;
    --border-inverted: #d9d7cd;
    --accent: #6fa0c4;
    --accent-strong: #8fb6d6;
    --accent-soft: #182430;
    --accent-secondary: #8fb0cc;
    --accent-on-inverted: #1f4560;
    --contact-bg: #24405c;
    --contact-bg-strong: #2f5175;
    --success: #3fbf87;
    --shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
  }

  * { box-sizing: border-box; }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background: var(--bg);
    color: var(--text-primary);
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    transition: background-color .25s ease, color .25s ease;
  }

  button, input, textarea {
    font: inherit;
    color: inherit;
  }

  a { color: inherit; }

  img { max-width: 100%; }

  ::selection {
    background: var(--accent);
    color: #fff;
  }

  :focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 3px;
    border-radius: 2px;
  }

  .skip-link {
    position: absolute;
    top: -100px;
    left: 12px;
    z-index: 100;
    background: var(--accent);
    color: #fff;
    padding: 10px 16px;
    border-radius: 4px;
    font-weight: 700;
    font-size: .85rem;
    text-decoration: none;
    transition: top .2s ease;
  }

  .skip-link:focus {
    top: 12px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default GlobalStyle;
